import { Quota } from './quota';
import { FilterHandler } from '../shared/filter-handler';
import { environment } from '../../environments/environment';

export class QuotaAggregate extends Quota {
  protected alertPercent = environment.cuotaAlertPercent;

  stock__id: number;
  stock__name: string;
  ships: string;
  expanded: boolean;
  details: Object[];

  public apiMap(values: Object = {}) {
    const quotaAggregate = new QuotaAggregate(values);
    quotaAggregate.alert = quotaAggregate.calculateAlert();
    return quotaAggregate;
  }
}

export class QuotaAggregateFilter extends FilterHandler {
  stock: string;
  year: string;
  ships: string[] = [];

  constructor(values: Object = {}) {
    super();

    this.stock = '';
    this.year = '';
    this.ships = [];

    this.unSerializedRouterParams(values);
  }
}



// WEBPACK FOOTER //
// ./src/app/_models/quota-aggregate.ts